import React from "react";
import styled from "styled-components";

const fontSize = [18, 16, 14, 12, 10, 8];
export default function VizButton({ children, onClick, size, type }) {
  const Primary = styled.button`
    font-size: ${fontSize[size - 1]}px;
    border: 1px solid var(--viz_primary_button_color);
    border-radius: 6px;
    text-transform: capitalize;
    background-color: var(--viz_primary_button_color);
    color: #fff;
    &:hover {
      color: #ffffff;
      background-color: var(--questionText_color);
      border-color: #fff;
    }
  `;
  const Secondary = styled.button`
    font-size: ${fontSize[size - 1]}px;
    border: 1px solid var(--viz_secondary_button_color);
    border-radius: 6px;
    text-transform: capitalize;
    background-color: var(--viz_secondary_button_color);
    color: #fff;
    &:hover {
      color: #ffffff;
      background-color: var(--questionText_color);
      border-color: #fff;
    }
  `;
  const Tertiary = styled.button`
    font-size: ${fontSize[size - 1]}px;
    border: 1px solid gray;
    border-radius: 6px;
    text-transform: capitalize;
    background-color: var(--viz_tertiary_button_color);
    color: gray;
    &:hover {
      color: #ffffff;
      background-color: gray;
      border-color: #fff;
    }
  `;
  const Disabled = styled.button`
    font-size: ${fontSize[size - 1]}px;
    border: 1px solid var(--viz_disabled_button_color);
    border-radius: 6px;
    text-transform: capitalize;
    background-color: var(--viz_disabled_button_color);
    color: #ffffff;
    pointer-events: none;
  `;
  return (
    <>
      {type == "Primary" && (
        <Primary onClick={(e) => onClick(e)}>{children}</Primary>
      )}
      {type == "Secondary" && (
        <Secondary onClick={() => onClick()}>{children}</Secondary>
      )}
      {type == "Tertiary" && (
        <Tertiary onClick={(e) => onClick(e)}>{children}</Tertiary>
      )}
      {type == "Disabled" && (
        <Disabled onClick={() => onClick()}>{children}</Disabled>
      )}
    </>
  );
}
